import { IUser } from '../interfaces/IUser';
import { USER_ROLES } from '../enums/UserRoles.enum';

export class UserOperations {
  public static isUserTechnicalController(user: IUser): boolean {
    return user ? user.role === USER_ROLES.TECHNISCHER_CONTROLLER : false;
  }

  public static isUserOnlineSupport(user: IUser): boolean {
    return user ? user.role === USER_ROLES.ONLINE_SUPPORT : false;
  }

  public static isUserTeamMember(user: IUser): boolean {
    return user ? user.role === USER_ROLES.TEAMMITGLIED : false;
  }

  public static isUserMercantileController(user: IUser): boolean {
    return user ? user.role === USER_ROLES.KAUFMANNISCHER_CONTROLLER : false;
  }

  public static isUserGroupLead(user: IUser): boolean {
    return user ? user.role === USER_ROLES.GRUPPENLEITER : false;
  }

  public static isUserTravelAccountant(user: IUser): boolean {
    return user ? user.role === USER_ROLES.TRAVEL_ACCOUNTANT : false;
  }

  public static isUserHeadOfBudget(user: IUser): boolean {
    return user ? user.role === USER_ROLES.BUDGETVERANTWORTLICHER : false;
  }

  public static isUserTimekeeper(user: IUser): boolean {
    return user ? user.isTimekeeper : false;
  }
}
